import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { openSearch } from '../../Layout/layoutActions';
import classNames from 'classnames';
import {
    debounce,
    isEqual
} from 'lodash';
import {
    goToSearchRoute,
    updateInputValue
} from '../searchActions';
import { getInputValue } from '../searchViewState';
import { getGoBackTarget } from '../../Routes/routesEntity';
import { goBack } from '../../Routes/routesActions';
import FilterDropDown from '../Filters/FilterDropDown';
import {
    goBackTargetShape,
    historyShape
} from '../../../utils/propTypes';
import { getCustomAccess } from '../../Self/selfEntity';
import { doesRoleHaveAccessToFeature } from '../../../utils/customRole';
import config from '../../../config/config';
import './Header.scss';

export class Header extends Component {
    static propTypes = {
        goBackTarget: goBackTargetShape,
        history: historyShape,
        inputValue: PropTypes.string,
        isSearchOpen: PropTypes.bool,
        match: PropTypes.any,
        onGoBack: PropTypes.func,
        onInputChange: PropTypes.func,
        onOpenSearch: PropTypes.func,
        onUpdateInputValue: PropTypes.func,
        customAccess: PropTypes.any
    };

    static defaultProps = {
        inputValue: ''
    };

    constructor(props) {
        super(props);

        this.handleClearInput = this.handleClearInput.bind(this);

        props.onUpdateInputValue(props.match.params.query);

        this.state = {
            animateSearch: props.isSearchOpen
        };
    }

    componentDidUpdate(previousProps) {
        if (!isEqual(previousProps.isSearchOpen, this.props.isSearchOpen)) {
            setTimeout(() => {
                this.setState({
                    animateSearch: this.props.isSearchOpen
                });
            }, 50);
            this.props.onUpdateInputValue('');
        }

        if (!isEqual(this.props.match.params.query, previousProps.match.params.query)) {
            this.props.onUpdateInputValue(this.props.match.params.query);
        }
    }

    handleClearInput() {
        this.props.onInputChange(this.props.history, this.props.match.params.filter)({
            target: {
                value: ''
            }
        });
    }

    render() {
        if (!doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.search]: ['GET/v3/all'] })) {
            return null;
        }

        const containerClassName = classNames('emvio-search', {
            'animate-search': this.state.animateSearch,
            'search-open': this.props.isSearchOpen
        });

        return (
            <div className={containerClassName}>
                <span className="icon-search" onClick={this.props.onOpenSearch(this.props.history)} />
                {this.props.isSearchOpen ? <div className="search-container">
                    <div className="icons">
                        <span className="icon-back"
                            onClick={this.props.onGoBack(this.props.history, this.props.goBackTarget)}
                        />
                    </div>
                    <FilterDropDown />
                    <input
                        autoFocus
                        onChange={this.props.onInputChange(this.props.history, this.props.match.params.filter)}
                        placeholder="Search"
                        value={this.props.inputValue}
                    />
                    <span className="icon-close" onClick={this.handleClearInput} />
                    <span className="icon-search" />
                </div> : null}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        goBackTarget: getGoBackTarget(state),
        inputValue: getInputValue(state),
        customAccess: getCustomAccess(state)
    };
}

function mapDispatchToProps(dispatch) {
    const debouncedGoToSearchRoute = debounce(goToSearchRoute, 1250);

    return {
        onGoBack: (history, goBackTarget) => () => goBack(history, goBackTarget),
        onInputChange: (history, filter) => (e) => {
            dispatch(updateInputValue(e.target.value));
            debouncedGoToSearchRoute(history, e.target.value, filter);
        },
        onOpenSearch: (history) => () => openSearch(history),
        onUpdateInputValue: (value) => dispatch(updateInputValue(value))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
